import { render, staticRenderFns } from "./ViewInvoicesPage.vue?vue&type=template&id=25876254&"
import script from "./ViewInvoicesPage.vue?vue&type=script&lang=js&"
export * from "./ViewInvoicesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports